import { APPCONFIG } from "../definitions";

const appConfigReducer = (state = { appConfig: [] }, action) => {
  switch (action.type) {
    case APPCONFIG.START_FETCH: {
      return {
        appConfig: [],
      };
    }
    case APPCONFIG.FINISH_FETCH: {
      return {
        appConfig: action.payload,
        error: "",
      };
    }
    case APPCONFIG.FAIL_FETCH: {
      return {
        error: action.payload,
      };
    }
    default:
      return state;
  }
};

export { appConfigReducer };
